export default __webpack_public_path__ + "static/media/new-logo2-cmtech.6026c900.png";